import { Panzoom } from '@fancyapps/ui/dist/panzoom/panzoom.esm.js'
import { isMobileWidth } from './_isMobileWidth.es6'

document.addEventListener('DOMContentLoaded', () => {
  /*------
  立面図のzoom/pan
  ------*/
  const floorGuideInner = document.querySelector('.floor-guide--inner')
  if (floorGuideInner) {
    const isSP = isMobileWidth()
    const ZOOM_STEP = 1

    const pz = new Panzoom(floorGuideInner, {
      click: 'false',
      minScale: 1,
      maxScale: isSP ? 1 : 1.5,
      bounce: false,
      rubberband: false,
      decelFriction: 0.2,
      panOnlyZoomed: false,
    })

    function zoomFloor(direction) {
      const current = pz.getMatrix()
      const currentScale = current.a
      const nextScale = direction === 'out' ? currentScale - ZOOM_STEP : currentScale + ZOOM_STEP

      const svgFloorRect = pz.content.getBoundingClientRect()
      const containerRect = floorGuideInner.getBoundingClientRect()

      const scrollX = Math.abs(svgFloorRect.left - containerRect.left)
      const contentRemainderX = (svgFloorRect.width - containerRect.width) / 2
      const scrollXAmountFromCenter = scrollX - contentRemainderX

      const scrollY = Math.abs(svgFloorRect.top - containerRect.top)
      const contentRemainderY = (svgFloorRect.height - containerRect.height) / 2
      const scrollYAmountFromCenter = scrollY - contentRemainderY

      pz.zoomTo(nextScale, {
        originX: scrollXAmountFromCenter,
        originY: scrollYAmountFromCenter,
      })
    }

    const zoomInBtn = document.querySelector('.floor-guide_zoom--link-zoomin')
    const zoomOutBtn = document.querySelector('.floor-guide_zoom--link-zoomout')

    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', (e) => {
        e.preventDefault()
        zoomFloor('in')
      })
    }

    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', (e) => {
        e.preventDefault()
        zoomFloor('out')
      })
    }

    // SP: ピンチインジケーターの表示
    if (isSP) {
      setTimeout(() => {
        floorGuideInner.classList.add('is_show')
      }, 100)
    }
  }

  /*------
  sp時のfilter
  ------*/
  if(isMobileWidth()) {
    const filterOpenElm = document.querySelector('.js-filter_open')
    const filterCloseElm = document.querySelectorAll('.js-filter_close')
  
    if (filterOpenElm) {
      // モ－ダル開閉
      filterOpenElm.addEventListener('click', function (e) {
        e.preventDefault()
        document.querySelector('body').classList.toggle('is_filter_open')
      })
  
      filterCloseElm.forEach(elm => {
        elm.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector('body').classList.remove('is_filter_open')
        })
      })


      // フッターが画面に入った分だけパネルの bottom を足して重ならないようにする
      const innerElm = document.querySelector('.js-filter-content')
      const footerElm = document.querySelector('.js-footer')

      let baseBottomPx = 0

      function updateInnerBottom() {
        const footerRect = footerElm.getBoundingClientRect()
        const vh = window.innerHeight
        const visibleFromBottom = Math.max(0, vh - footerRect.top) // フッターが画面下端から何 px 見えているか
        if (visibleFromBottom === 0) {
          innerElm.style.removeProperty('bottom')
          baseBottomPx = parseFloat(getComputedStyle(innerElm).bottom) || 0
        } else {
          innerElm.style.setProperty('bottom', `${baseBottomPx + visibleFromBottom}px`)
        }
      }
      innerElm.style.removeProperty('bottom')
      baseBottomPx = parseFloat(getComputedStyle(innerElm).bottom) || 0
      window.addEventListener('scroll', updateInnerBottom, { passive: true })
      window.addEventListener('resize', updateInnerBottom)
      updateInnerBottom()
      document.querySelector('.js-floor_more_btn')?.addEventListener('click', function () {
        // 同じボタンの別リスナー（検索機能ブロック内）で showAllMore() が走ったあと、
        // コンテンツ増加に合わせてフィルタパネルの bottom を再計算する。
        // setTimeout(..., 0) は「次のタスクで実行」の指定（時間の指定ではない）。
        setTimeout(updateInnerBottom, 0)
      })
    }
  }


  /*------
  filterの検索機能
  ------*/
  const selectForm = document.querySelector('.js-select_form')

  if (selectForm) {
    const category = selectForm.dataset.category

    // categoryごとに使用するstatusのキーを定義
    const CATEGORY_STATUS_KEYS = {
      restaurant: ['type', 'floor', 'stair'],
      shop: ['type']
    }
    const statusKeys = CATEGORY_STATUS_KEYS[category]

    const INITIAL_DISPLAY_COUNT = 12
    const tenantList = document.querySelector('.js-floor_tenant_list')
    const floorCountElm = document.querySelector('.js-floor_count')
    const moreBtn = document.querySelector('.js-floor_more_btn')

    const getInitialStatus = () =>
      Object.fromEntries(statusKeys.map((key) => [key, []]))

    let shopElms = Array.from(tenantList.querySelectorAll('.floor-tenant_list--item'))
    let status = getInitialStatus()

    /** 表示中の店舗要素（.is_shop_show を持つもの）を返す */
    const getVisibleShops = () =>
      shopElms.filter((elm) => elm.classList.contains('is_shop_show'))

    /** 指定キーの値が条件に一致するか（空配列の場合は常にtrue） */
    const matchesStatus = (item, key) =>
      status[key].length === 0 || status[key].includes(item.dataset[key])

    /** moreボタンの表示／非表示を制御 */
    const toggleMoreBtn = () => {
      const visibleCount = getVisibleShops().length
      moreBtn?.classList.toggle('is_more_btn_show', visibleCount > INITIAL_DISPLAY_COUNT)
    }

    const setStatus = (parameter, value) => {
      if (!Array.isArray(status[parameter])) return
      status[parameter] = [...new Set([...status[parameter], value])]
    }

    /** フィルタ条件に応じて表示店舗を更新 */
    const applyFilter = () => {
      shopElms.forEach((elm) => elm.classList.remove('is_shop_show'))

      const matched = shopElms.filter((item) =>
        statusKeys.every((key) => matchesStatus(item, key))
      )
      matched.forEach((item) => item.classList.add('is_shop_show'))

      if (floorCountElm) floorCountElm.textContent = matched.length
    }

    /** 先頭N件に「もっと見る」表示を付け、moreボタンの表示を更新 */
    const applyInitialMoreDisplay = () => {
      shopElms.forEach((elm) => elm.classList.remove('is_more_shop_show'))
      getVisibleShops()
        .slice(0, INITIAL_DISPLAY_COUNT)
        .forEach((elm) => elm.classList.add('is_more_shop_show'))
      toggleMoreBtn()
    }

    /** 全表示店舗を「もっと見る」で表示済みにする */
    const showAllMore = () => {
      getVisibleShops().forEach((elm) => elm.classList.add('is_more_shop_show'))
      moreBtn?.classList.remove('is_more_btn_show')
    }

    /** SP時: フィルタを閉じて結果エリアへスクロール */
    const closeFilterAndScrollToResult = () => {
      if (!isMobileWidth()) return
      document.querySelector('body').classList.remove('is_filter_open')
      const result = document.getElementById('result')
      if (result) result.scrollIntoView({ behavior: 'smooth' })
    }

    // テナントをランダム順で表示
    shopElms = [...shopElms].sort(() => Math.random() - 0.5)
    tenantList?.append(...shopElms)

    applyFilter()
    applyInitialMoreDisplay()

    selectForm.addEventListener('submit', (e) => {
      e.preventDefault()
      status = getInitialStatus()
      selectForm.querySelectorAll('input:checked').forEach((elm) => {
        setStatus(elm.name, elm.value)
      })
      // 検索時はdata-orderの順番でソート
      shopElms.sort((a, b) => {
        const orderA = parseInt(a.dataset.order) || 999
        const orderB = parseInt(b.dataset.order) || 999
        return orderA - orderB
      })
      tenantList?.append(...shopElms)
      applyFilter()
      applyInitialMoreDisplay()
      closeFilterAndScrollToResult()
    })

    const resetBtn = document.querySelector('.js-select_reset')
    resetBtn?.addEventListener('click', (e) => {
      e.preventDefault()
      selectForm.querySelectorAll('input:checked').forEach((elm) => {
        elm.checked = false
      })
      status = getInitialStatus()
      // リセット時はランダム順に戻す
      shopElms.sort(() => Math.random() - 0.5)
      tenantList?.append(...shopElms)
      applyFilter()
      applyInitialMoreDisplay()
      closeFilterAndScrollToResult()
    })

    moreBtn?.addEventListener('click', (e) => {
      e.preventDefault()
      showAllMore()
    })
  }
})